/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-06-13-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { withI18n } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { Button, TextStyle } from '@shopify/polaris';
import { CancelSmallMinor } from '@shopify/polaris-icons';
import history from 'src/routes/history';
import { routes } from 'src/routes';

import { updateTenantApp, updateLocalTenantApp } from 'actions/oauth-actions';

import PersonalizationMarketingCampaign from 'src/assets/images/campaigns/personalization-present-banner-01.png';
import arrowRight from 'src/assets/images/campaigns/arrow-right-minor.png';

class MarketingCampaignBanner extends Component<Props> {
  render() {
    const { type, handleDismissBanner } = this.props;
    const renderData = this.renderComponent(type);
    return (
      <div className="BC-MarketingCampaignBanner">
        <div className="BC-MarketingCampaignBanner-inner">
          <div className="banner-dismiss">
            <Button onClick={() => handleDismissBanner(type)} icon={CancelSmallMinor} plain />
          </div>
          <div className="banner-detail">
            <div className="banner-content">{renderData}</div>
            {/* Render image banner */}
            <div className="image">
              <img src={PersonalizationMarketingCampaign} alt="Personalization Present Banner" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderComponent = type => {
    const components = {
      request: this.renderRequestBanner,
      notChosen: this.renderNotChosenBanner,
      trial: this.renderTrialBanner,
      expiredSoon: this.renderExpiredSoonBanner,
      expired: this.renderExpiredBanner,
      discount: this.renderDiscountBanner
    };

    return components[type]() || '';
  };

  renderRequestBanner = () => {
    const { i18n, updateTenantAppLoading } = this.props;
    return (
      <>
        <div className="title">
          {i18n.translate('AdminHTML.MarketingCampaign.RequestBanner.title', {
            t1: (
              <span className="title-color">
                {i18n.translate('AdminHTML.MarketingCampaign.RequestBanner.title_t1')}
              </span>
            )
          })}
        </div>
        <p>
          {i18n.translate('AdminHTML.MarketingCampaign.RequestBanner.content', {
            t1: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.MarketingCampaign.RequestBanner.content_t1')}
              </TextStyle>
            ),
            t2: (
              <TextStyle variation="strong">
                <span className="text-gradient">
                  {i18n.translate('AdminHTML.MarketingCampaign.RequestBanner.content_t2')}
                </span>
              </TextStyle>
            ),
            t3: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.MarketingCampaign.RequestBanner.content_t3')}
              </TextStyle>
            )
          })}
        </p>
        <div>
          <Button
            destructive
            size="slim"
            onClick={this.handleRegisterCampaign}
            loading={updateTenantAppLoading}>
            {i18n.translate(`AdminHTML.MarketingCampaign.RequestBanner.action`)}
            <img src={arrowRight} alt="action-icon-primary" />
          </Button>
          <span className="text-note">
            {i18n.translate(`AdminHTML.MarketingCampaign.RequestBanner.note`)}
          </span>
        </div>
      </>
    );
  };

  renderNotChosenBanner = () => {
    const { i18n } = this.props;
    return (
      <>
        <div className="title">
          {i18n.translate('AdminHTML.MarketingCampaign.NotChosenBanner.title')}
        </div>
        <p>
          {i18n.translate('AdminHTML.MarketingCampaign.NotChosenBanner.content', {
            t1: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.MarketingCampaign.NotChosenBanner.content_t1')}
              </TextStyle>
            ),
            t2: (
              <TextStyle variation="strong">
                <span className="text-gradient">
                  {i18n.translate('AdminHTML.MarketingCampaign.NotChosenBanner.content_t2')}
                </span>
              </TextStyle>
            ),
            t3: (
              <TextStyle variation="strong">
                <span className="text-gradient">
                  {i18n.translate('AdminHTML.MarketingCampaign.NotChosenBanner.content_t3')}
                </span>
              </TextStyle>
            )
          })}
        </p>
        <div>
          <Button destructive size="slim" onClick={this.handleProfessionalPackagePage}>
            {i18n.translate(`AdminHTML.MarketingCampaign.NotChosenBanner.action`)}
            <img src={arrowRight} alt="action-icon-primary" />
          </Button>
          <span className="text-note">
            {i18n.translate(`AdminHTML.MarketingCampaign.NotChosenBanner.note`)}
          </span>
        </div>
      </>
    );
  };

  renderTrialBanner = () => {
    const { i18n } = this.props;
    return (
      <>
        <div className="title">
          {i18n.translate('AdminHTML.MarketingCampaign.TrialBanner.title', {
            t1: (
              <span className="title-color">
                {i18n.translate('AdminHTML.MarketingCampaign.TrialBanner.title_t1')}
              </span>
            )
          })}
        </div>
        <p>
          {i18n.translate('AdminHTML.MarketingCampaign.TrialBanner.content', {
            t1: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.MarketingCampaign.TrialBanner.content_t1')}
              </TextStyle>
            ),
            t2: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.MarketingCampaign.TrialBanner.content_t2')}
              </TextStyle>
            ),
            t3: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.MarketingCampaign.TrialBanner.content_t3')}
              </TextStyle>
            )
          })}
        </p>
        <div>
          <Button destructive size="slim" onClick={this.handleOpenWidgetPage}>
            {i18n.translate(`AdminHTML.MarketingCampaign.TrialBanner.action`)}
            <img src={arrowRight} alt="action-icon-primary" />
          </Button>
        </div>
      </>
    );
  };

  renderExpiredSoonBanner = () => {
    const { i18n } = this.props;
    return (
      <>
        <div className="title">
          {i18n.translate('AdminHTML.MarketingCampaign.ExpiredSoonBanner.title', {
            t1: (
              <span className="text-gradient">
                {i18n.translate('AdminHTML.MarketingCampaign.ExpiredSoonBanner.title_t1')}
              </span>
            )
          })}
        </div>
        <p>
          {i18n.translate('AdminHTML.MarketingCampaign.ExpiredSoonBanner.content', {
            t1: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.MarketingCampaign.ExpiredSoonBanner.content_t1')}
              </TextStyle>
            ),
            t2: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.MarketingCampaign.ExpiredSoonBanner.content_t2')}
              </TextStyle>
            ),
            t3: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.MarketingCampaign.ExpiredSoonBanner.content_t3')}
              </TextStyle>
            )
          })}
        </p>
        <div>
          <Button destructive size="slim" onClick={this.handleProfessionalPackagePage}>
            {i18n.translate(`AdminHTML.MarketingCampaign.ExpiredSoonBanner.action`)}
            <img src={arrowRight} alt="action-icon-primary" />
          </Button>
        </div>
      </>
    );
  };

  renderExpiredBanner = () => {
    const { i18n } = this.props;
    return (
      <>
        <div className="title">
          {i18n.translate('AdminHTML.MarketingCampaign.ExpiredBanner.title', {
            t1: (
              <span className="text-gradient">
                {i18n.translate('AdminHTML.MarketingCampaign.ExpiredBanner.title_t1')}
              </span>
            )
          })}
        </div>
        <p>
          {i18n.translate('AdminHTML.MarketingCampaign.ExpiredBanner.content', {
            t1: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.MarketingCampaign.ExpiredBanner.content_t1')}
              </TextStyle>
            ),
            t2: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.MarketingCampaign.ExpiredBanner.content_t2')}
              </TextStyle>
            ),
            t3: (
              <TextStyle variation="strong">
                <span className="text-gradient">
                  {i18n.translate('AdminHTML.MarketingCampaign.ExpiredBanner.content_t3')}
                </span>
              </TextStyle>
            ),
            t4: (
              <TextStyle variation="strong">
                <span className="text-gradient">
                  {i18n.translate('AdminHTML.MarketingCampaign.ExpiredBanner.content_t4')}
                </span>
              </TextStyle>
            )
          })}
        </p>
        <div>
          <Button destructive size="slim" onClick={this.handleOpenSurvey}>
            {i18n.translate(`AdminHTML.MarketingCampaign.ExpiredBanner.action`)}
            <img src={arrowRight} alt="action-icon-primary" />
          </Button>
          <span className="text-note">
            {i18n.translate(`AdminHTML.MarketingCampaign.ExpiredBanner.note`)}
          </span>
        </div>
      </>
    );
  };

  renderDiscountBanner = () => {
    const { i18n } = this.props;
    return (
      <>
        <div className="title">
          {i18n.translate('AdminHTML.MarketingCampaign.DiscountBanner.title')}
        </div>
        <p>
          {i18n.translate('AdminHTML.MarketingCampaign.DiscountBanner.content', {
            t1: (
              <TextStyle variation="strong">
                <span className="text-gradient">
                  {i18n.translate('AdminHTML.MarketingCampaign.DiscountBanner.content_t1')}
                </span>
              </TextStyle>
            ),
            t2: (
              <TextStyle variation="strong">
                <span className="text-gradient">
                  {i18n.translate('AdminHTML.MarketingCampaign.DiscountBanner.content_t2')}
                </span>
              </TextStyle>
            ),
            t3: (
              <TextStyle variation="strong">
                {i18n.translate('AdminHTML.MarketingCampaign.DiscountBanner.content_t3')}
              </TextStyle>
            )
          })}
        </p>
        <div>
          <Button destructive size="slim" onClick={this.handleProfessionalPackagePage}>
            {i18n.translate(`AdminHTML.MarketingCampaign.DiscountBanner.action`)}
            <img src={arrowRight} alt="action-icon-primary" />
          </Button>
          <span className="text-note">
            {i18n.translate(`AdminHTML.MarketingCampaign.DiscountBanner.note`)}
          </span>
        </div>
      </>
    );
  };

  // Handle change personalization campaign status
  handleRegisterCampaign = () => {
    const { updateTenantApp, updateLocalTenantApp } = this.props;
    const meta = {
      onSuccess: () => {
        updateLocalTenantApp({ showConfirmedPersonalizationCampaignPopup: true });
      }
    };
    updateTenantApp({ personalizationCampaignStatus: 'registered' }, meta);
  };

  // Handle open discount page
  handleProfessionalPackagePage = () => {
    history.push({
      pathname: routes.subscription.package(),
      state: { selectedPackage: 'professional' }
    });
  };

  // Handle open widget page
  handleOpenWidgetPage = () => {
    history.push(routes.recommendationWidgets.newPersonalized());
  };

  // Handle open survey page
  handleOpenSurvey = () => {
    //TODO: Open survey page
    console.log('open survey');
  };
}

const mapStateToProps = (state, props) => ({
  updateTenantAppLoading: _.get(state.oauth, 'loadingUpdate', false)
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  updateTenantApp: (body, meta) => dispatch(updateTenantApp(body, meta, ownProps.i18n)),
  updateLocalTenantApp: body => dispatch(updateLocalTenantApp(body))
});
export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(MarketingCampaignBanner));
